import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c(VDataTable, {
        staticClass: "table-inca elevation-1",
        attrs: {
          id: "main-table",
          items: _vm.items,
          headers: _vm.fields,
          outlined: "",
          responsive: "",
          hover: "",
          "show-empty": "",
          "pagination-disabled": "",
          "hide-default-footer": "",
          busy: _vm.isLoading,
          "sticky-header": true,
        },
        scopedSlots: _vm._u([
          {
            key: "table-busy",
            fn: function () {
              return [_c("base-loading")]
            },
            proxy: true,
          },
          {
            key: "item.actions",
            fn: function (ref) {
              var item = ref.item
              return [
                _c(
                  VBtn,
                  {
                    directives: [
                      {
                        name: "b-tooltip",
                        rawName: "v-b-tooltip.hover.bottom",
                        modifiers: { hover: true, bottom: true },
                      },
                    ],
                    staticClass: "btn-icon-inca",
                    attrs: {
                      variant: "outline-secondary",
                      title: "Remove Access",
                      small: "",
                      icon: "",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.showModalWithData(
                          item,
                          _vm.MODAL_CONFIRM_REMOVE_ACCESS
                        )
                      },
                    },
                  },
                  [
                    _c(VIcon, { attrs: { small: "" } }, [
                      _vm._v("icon-delete"),
                    ]),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
      _c(
        "b-modal",
        {
          ref: _vm.MODAL_CONFIRM_REMOVE_ACCESS,
          attrs: {
            id: _vm.MODAL_CONFIRM_REMOVE_ACCESS,
            title: "CONFIRM REMOVE ACCESS",
            size: "sm",
            "hide-footer": "",
          },
        },
        [
          _c("modal-confirm", {
            attrs: {
              message:
                "Do you want to remove the access for " + _vm.item.owner + "?",
            },
            on: {
              submitItem: function ($event) {
                return _vm.removeAccess(_vm.item)
              },
              closeConfirmModal: function ($event) {
                return _vm.$bvModal.hide(_vm.MODAL_CONFIRM_REMOVE_ACCESS)
              },
            },
          }),
          _c("b-overlay", {
            attrs: {
              show: _vm.isBusy,
              "no-wrap": "",
              rounded: "lg",
              opacity: "0.85",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }